import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["orientation", "type", "blockSize"];
import devLogger from 'react-utils/devLogger';
import { DeviceFrameDesktop } from './DeviceFrameDesktop';
import { DeviceFrameTablet } from './DeviceFrameTablet';
import { DeviceFrameMobile } from './DeviceFrameMobile';
import { jsx as _jsx } from "react/jsx-runtime";
const DEVICE_TYPES = {
  desktop: DeviceFrameDesktop,
  tablet: DeviceFrameTablet,
  mobile: DeviceFrameMobile
};
export function DeviceFrame(_ref) {
  let {
      orientation = 'portrait',
      type = 'desktop',
      blockSize
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const Frame = DEVICE_TYPES[type];
  if (process.env.NODE_ENV !== 'production') {
    if (type === 'desktop' && orientation === 'landscape') {
      devLogger.warn({
        message: `DeviceFrame: There is no designed state for a landscape desktop device frame.
            Change either the \`type\` or the \`orientation\``,
        key: 'DeviceFrame: landscape desktop'
      });
    }
    if (blockSize && type !== 'desktop') {
      devLogger.warn({
        message: `DeviceFrame: Only the desktop device frame applies the blockSize prop.`,
        key: 'DeviceFrame: blockSize only applies to desktop'
      });
    }
  }
  return /*#__PURE__*/_jsx(Frame, Object.assign({}, rest, {
    blockSize: blockSize,
    orientation: orientation
  }));
}